import { NavLink } from "react-router-dom";

interface BreadCrumbItemProps {
  path: string;
  name: string;
  active: boolean;
}

function BreadCrumbItem({ name, path, active }: BreadCrumbItemProps) {
  return (
    <>
      <NavLink
        to={path}
        // className={`${
        //   active ? "text-blue-500" : "text-gray-700"
        // } text-md font-bold`}
      >
        {name} <span>/</span>
      </NavLink>
    </>
  );
}

export default BreadCrumbItem;
